/* eslint-disable import/prefer-default-export */

export const PIPELINE_SLIDING_PANE_PIPELINE_CHANGED = 'PIPELINE_SLIDING_PANE_PIPELINE_CHANGED';
export const FOLLOW_UP_CHANGED = 'FOLLOW_UP_CHANGED';
export const CREATE_CALENDAR_EVENT_FROM_PIPELINE = 'CREATE_CALENDAR_EVENT_FROM_PIPELINE';
export const CLOSE_CALENDAR_EVENT_MODAL = 'CLOSE_CALENDAR_EVENT_MODAL';
export const OFFER_CHANGED = 'OFFER_CHANGED';
export const SUBMITTING_FORM_CHANGED = 'SUBMITTING_FORM_CHANGED';
